// 记录本地的数组key name
export const PAGESIZE_CG_KEY = 'PAGESIZE_CG_KEY'
// 分销订单
export const PS_DISTRIBUTE_ORDER = 'PS_DISTRIBUTE_ORDER'
// 普通订单
export const PS_GENERAL_ORDER = 'PS_GENERAL_ORDER'
// 导入店铺商品
export const IMPORT_SHOP_LIST = 'IMPORT_SHOP_LIST'
